import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { BaseSafeFormView, BaseView, BaseText } from '@/components/base'
import { AppButton } from '@/components/AppButton'
import { StickyHeaderNavigation } from '@/components'
import { useTheme } from '@/hooks/useTheme'
import { useUserStore } from '@/store'
import SafeAreaLayout from '@/components/layout/SafeAreaLayout'

export const AddPhoneScreen: React.FC = () => {
  const { t } = useTranslation()
  const theme = useTheme()
  const navigate = useNavigate()
  const userAuthenticated = useUserStore((state) => state.userAuthenticated)

  // Redirect if user already has phone number
  useEffect(() => {
    if (userAuthenticated?.phone_number) {
      navigate('/dashboard')
    }
  }, [userAuthenticated?.phone_number, navigate])

  const handleContinue = () => {
    navigate('/add-phone/enter-phone')
  }

  return (
    <>
      <BaseView className="h-screen flex flex-col overflow-hidden">
        <StickyHeaderNavigation
          title={t('screens:addPhone.title')}
          showBackground={false}
        />
        <SafeAreaLayout isStretch hasNavBar>
          {/* Gradient background */}

          <BaseView
            className="fixed inset-0 z-0"
            style={{
              backgroundImage: 'url(/assets/images/add-new-phone-bg.png)',
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'flex-end',
            }}
          />

          {/* Main content - copy of RN BaseSafeAreaView */}
          <BaseView
            flex={1}
            className="relative z-10 flex flex-col overflow-hidden"
            px={12}
            style={{
              paddingTop: 'env(safe-area-inset-top)', // Safe area support for iOS
              paddingLeft: 'env(safe-area-inset-left)',
              paddingRight: 'env(safe-area-inset-right)',
              minHeight: 0, // Important for flex containers
            }}
          >
            <BaseView
              p={20}
              align="center"
              justify="flex-end"
              gap={42}
              flex={1}
              style={{ overflow: 'hidden' }}
            >
              <div
                style={{
                  width: '100%',
                  maxHeight: '497px',
                  height: '100%',
                  marginTop: 'auto',
                  marginBottom: 'auto',
                  backgroundImage: 'url(/assets/images/big-phone.png)',
                  backgroundSize: 'contain',
                  backgroundPosition: 'center',
                  backgroundRepeat: 'no-repeat',
                }}
              />
              <BaseView gap={16} align="center">
                <BaseText
                  fontSize={28}
                  fontFamily="semibold"
                  color="label.default"
                  textAlign="center"
                >
                  {t('screens:addPhone.description')}
                </BaseText>

                {/* <BaseText
                fontSize={16}
                fontFamily="regular"
                color="label.default"
                textAlign="center"
              >
                {t('translation:kemCardDescription')}
              </BaseText> */}
              </BaseView>

              <AppButton
                label={t('form:actions.continue')}
                onPress={handleContinue}
                disabled={false}
                isLoading={false}
                type="blur"
                style={{
                  backgroundColor: 'rgb(255 255 255 / 10%)',
                }}
              />
            </BaseView>
          </BaseView>
        </SafeAreaLayout>
      </BaseView>
    </>
  )
}

export default AddPhoneScreen
